import {
  TNavItemsEvent,
  TScreenView,
  TClickEvent,
  TEnableRefresh,
} from "../services/JsBridgeService";
import { CommonRuntime } from "utils/runtime";
import { judgeAppVersion } from "utils/app";

let debug = false;

const checkObjIsFunction = function (targetObj: any, path: string): boolean {
  if (typeof targetObj !== "undefined" && targetObj !== null) {
    const [currentPath, ...otherPaths] = path.split(".");
    if (
      otherPaths.length === 0 &&
      (targetObj[currentPath] === "function" ||
        (typeof targetObj === "function" && path === ""))
    ) {
      return true;
    }
    return typeof targetObj[currentPath] === "undefined"
      ? false
      : checkObjIsFunction(targetObj[currentPath], otherPaths.join("."));
  }
  return false;
};

const callBridge = function (callKey: string, data: any) {
  const JSBridgeCheckResult = checkObjIsFunction(window, `JSBridge.${callKey}`);
  const messageHandlerCheckResult = checkObjIsFunction(
    window,
    `webkit.messageHandlers.${callKey}.postMessage`
  );
  if (JSBridgeCheckResult) {
    window.JSBridge[callKey](JSON.stringify(data));
  }
  if (messageHandlerCheckResult) {
    window.webkit.messageHandlers[callKey].postMessage(data);
  }

  if (debug) {
    console.log(
      `JSBridge/MessageHandler CheckResult: ${JSBridgeCheckResult} ${messageHandlerCheckResult}`
    );
    console.log(`Method: ${callKey} Data:`);
  }
};

export interface IProductSimple {
  url: string;
  name: string;
  price: string;
}

export interface IViewProduct {
  products: IProductSimple[];
  category: string;
  offset: number;
}

export const viewProduct = function (obj: IViewProduct) {
  callBridge("viewProduct", obj);
};

export const clickEvent = function (obj: TClickEvent) {
  callBridge("clickEvent", obj);
};

export const screenView = function (obj: TScreenView) {
  callBridge("screenView", obj);
};

export const navItemsEvent = function (obj: TNavItemsEvent) {
  callBridge("navItemsEvent", obj);
};

export const enableRefresh = function (obj: TEnableRefresh) {
  callBridge("enableRefresh", obj);
};

export const enableDebug = function () {
  debug = true;
};

export const callAndroid = function (callKey: string, ...args) {
  const AndroidCheckResult = checkObjIsFunction(window, `Android.${callKey}`);
  if (AndroidCheckResult) {
    console.log("安卓调到这里了吗", `window.Android[${callKey}]`);
    window.Android[callKey](...args);
    return;
  }
  return;
};

export const trackBILog = function (url: string, runtime: CommonRuntime) {
  const { isInApp, client } = runtime;
  if (isInApp) {
    const callKey = "trackBILog";
    client === "android"
      ? judgeAppVersion({ runtime, androidVersion: 20300 })
        ? callAndroid(callKey, url)
        : null
      : callBridge(callKey, { url });
    return;
  }
  return;
};
